const recaptchaSiteKey = '6Ldk10YqAAAAAKvsFWxYH8SDBEfAxNdFqcA2JfDV';

// To check location
const isLocalhost = window.location.host.includes('localhost');
const isProduction = window.location.host.includes('jobshot.ai') || window.location.host.includes('olaris.web.app');
const isAdmin = window.location.pathname.startsWith('/admin');
const isApp = window.location.pathname.startsWith('/app') || window.location.pathname.startsWith('/profile');
const isLogin = window.location.pathname.startsWith('/login');
const isSignUp = window.location.pathname.startsWith('/signup');
const isVerify = window.location.pathname.startsWith('/verify');
const isAuth = isLogin || isSignUp || isVerify;

// Skills
const SKILLS_MAX_SHOWN = 10;
const SKILLS_CUT_TOLERANCE = 5;

// URL
const buildUrlObject = function(){
  let url = {
    url: new URL(window.location.href),
    host: window.location.host,
    pathname: window.location.pathname,
    href: window.location.href,
    parameters: {},
  }
  const p = new URLSearchParams(url.url.search);
  p.forEach((value, key) => {
    url.parameters[key] = value;
  });
  return url;
}
const url = buildUrlObject();

// Single element selector
const qS = (selector) => document.querySelector(selector);
window.qS = qS;

// Multiple elements selector
const qSA = (selector) => document.querySelectorAll(selector);
window.qSA = qSA;

// Random hash
function randomHash(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

// Converters
function toSnakeCase(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
}
function toCamelCase(str) {
  return str.toLowerCase().replace(/(_\w)/g, match => match[1].toUpperCase());
}

// Check if string can be used as id for db
function isValidIdString(input) {
  const pattern = /^[a-z_][a-z0-9_]*$/;
  return pattern.test(input);
}

// Check if string can be used as option name (numbers allowed)
function isValidOptionName(input) {
  const pattern = /^[a-z0-9_][a-z0-9_]*$/;
  return pattern.test(input);
}

// Check if string can be used as uri
function isValidUri(input) {
  const pattern = /^[a-z][a-z0-9-]*$/; // Allow dashes, but not underscores
  return pattern.test(input);
}

function getEmailOrPhoneObject(input) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/;
  if (emailRegex.test(input)) return { email: input };
  if (phoneRegex.test(input)) return { phoneNumber: input };
  return {};
}

// Link a row
const link = function(text, url, coverInBanksyMode = false, target = '_self'){
  const classes = coverInBanksyMode ? 'class="cover-in-banksy-mode"' : '';
  return `<a href="${url}" ${classes} target="${target}">${text}</a>`;
}

// Array from comma separated string
function getArrayFromCommaSeparatedList(selector) {
  const value = qS(selector).value;
  const list = value.split(', ').map(item => item.trim());
  return list[0] === '' ? [] : list;
}

// Cover for banksy mode
const coverAfterXWordsInBanksyMode = function(string, hideAfterWord = 3){
  return string.split(" ").length > hideAfterWord
        ? string.split(" ").slice(0, hideAfterWord).join(" ") + ` <span class="cover-in-banksy-mode">` + string.split(" ").slice(hideAfterWord).join(" ") + `</span>`
        : string;
}
const coverNameInBanksyMode = function(string, name){
  const names = name.split(" ");
  names.forEach(n => {
    string = string.replaceAll(n, `<span class="cover-in-banksy-mode">${n}</span>`);
  });
  return string;
}

// Export
export { isLocalhost, isProduction, isAdmin, isApp, isAuth, isLogin, isSignUp, isVerify, url, qS, qSA, recaptchaSiteKey, coverAfterXWordsInBanksyMode, coverNameInBanksyMode, randomHash, toSnakeCase, toCamelCase, SKILLS_MAX_SHOWN, SKILLS_CUT_TOLERANCE, isValidIdString, isValidOptionName, isValidUri, link, getEmailOrPhoneObject, getArrayFromCommaSeparatedList };